/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type GenerateTitleRequestBody = {
  /**
   * The ID of the chat
   */
  id: string;
  /**
   * When present, sets the chat's title manually (empty string resets to auto-generated). When omitted, the current title is returned without changes.
   */
  title?: string | undefined;
};

/** @internal */
export type GenerateTitleRequestBody$Outbound = {
  id: string;
  title?: string | undefined;
};

/** @internal */
export const GenerateTitleRequestBody$outboundSchema: z.ZodMiniType<
  GenerateTitleRequestBody$Outbound,
  GenerateTitleRequestBody
> = z.object({
  id: z.string(),
  title: z.optional(z.string()),
});

export function generateTitleRequestBodyToJSON(
  generateTitleRequestBody: GenerateTitleRequestBody,
): string {
  return JSON.stringify(
    GenerateTitleRequestBody$outboundSchema.parse(generateTitleRequestBody),
  );
}
